module.exports = __webpack_public_path__ + "img/coupon-item-valid-bg.eb01086b.png";